import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { eur } from "@/lib/constants";

export default function ReturnDialog({ open, onOpenChange, activeRes, ret, setRet, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-zinc-800 bg-zinc-950">
        <DialogHeader><DialogTitle className="text-white">État des lieux de retour</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-zinc-400">État du matériel</Label>
            <div className="mt-1.5 grid grid-cols-2 gap-2">
              <button data-testid="condition-ok" onClick={() => setRet({ ...ret, condition: "ok" })} className={`rounded-xl border p-3 text-sm ${ret.condition === "ok" ? "border-emerald-500 bg-emerald-500/10 text-emerald-300" : "border-zinc-800 bg-zinc-900 text-zinc-400"}`}>Bon état</button>
              <button data-testid="condition-dommage" onClick={() => setRet({ ...ret, condition: "dommage", caution_action: "retenir" })} className={`rounded-xl border p-3 text-sm ${ret.condition === "dommage" ? "border-red-500 bg-red-500/10 text-red-300" : "border-zinc-800 bg-zinc-900 text-zinc-400"}`}>Dommage constaté</button>
            </div>
          </div>
          {activeRes?.caution_amount > 0 && (
            <div>
              <Label className="text-zinc-400">Caution ({eur(activeRes.caution_amount)})</Label>
              <div className="mt-1.5 grid grid-cols-2 gap-2">
                <button data-testid="caution-liberer" onClick={() => setRet({ ...ret, caution_action: "liberer" })} className={`rounded-xl border p-3 text-sm ${ret.caution_action === "liberer" ? "border-emerald-500 bg-emerald-500/10 text-emerald-300" : "border-zinc-800 bg-zinc-900 text-zinc-400"}`}>Libérer la caution</button>
                <button data-testid="caution-retenir" onClick={() => setRet({ ...ret, caution_action: "retenir" })} className={`rounded-xl border p-3 text-sm ${ret.caution_action === "retenir" ? "border-red-500 bg-red-500/10 text-red-300" : "border-zinc-800 bg-zinc-900 text-zinc-400"}`}>Retenir</button>
              </div>
              {ret.caution_action === "retenir" && (
                <div className="mt-3"><Label className="text-zinc-400">Montant retenu (€)</Label><Input data-testid="retained-amount" type="number" max={activeRes.caution_amount} className="mt-1 border-zinc-800 bg-zinc-900" value={ret.retained_amount} onChange={(e) => setRet({ ...ret, retained_amount: e.target.value })} /></div>
              )}
            </div>
          )}
          <div><Label className="text-zinc-400">Notes</Label><Textarea className="mt-1 border-zinc-800 bg-zinc-900" placeholder="Observations…" value={ret.notes} onChange={(e) => setRet({ ...ret, notes: e.target.value })} /></div>
          <Button data-testid="confirm-return" onClick={onConfirm} className="w-full rounded-full bg-[#FF6A00] font-semibold text-white hover:bg-[#E65F00]">Valider le retour</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
